exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ExtraButtons .popover-trigger-button{width:auto}.ExtraButtons .popover-trigger{position:static;padding:10px;margin:-10px}.ExtraButtons .popover-trigger:hover .svg-inline--fa{color:#b9b9ba;color:var(--text,#b9b9ba)}", ""]);

// exports
